/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Group_Type_SubtitleInputs */



/**
* | output |
* | --- |
* | "Subtitle" |
*
* @param {Merge_Event_Group_Group_Type_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_group_type_subtitle = /** @type {((inputs?: Merge_Event_Group_Group_Type_SubtitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Group_Type_SubtitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtitular")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legenda")
	return /** @type {LocalizedString} */ ("Subtitle")
});